"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownTabs = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2020 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var Tabs_1 = require("../Tabs");
/**
 * @internal
 */
exports.DropdownTabs = function (_a) {
    var tabs = _a.tabs, selectedTabId = _a.selectedTabId, onTabSelect = _a.onTabSelect;
    return (react_1.default.createElement(Tabs_1.Tabs, { tabs: tabs, className: "gd-dropdown-tabs", selectedTabId: selectedTabId, onTabSelect: onTabSelect }));
};
//# sourceMappingURL=DropdownTabs.js.map